// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"21a7cce6","131":"eb87837c","171":"fb601379","374":"a0156d4b","443":"d810de06","480":"45a51e6f","895":"bc9360e6"}[chunkId] + ".chunk.js";
};